import React from "react";
interface ICarouselWrapperProps {
    index: number;
}

// carousel-wrapper-container
const CarouselWrapper: React.FC<
    React.PropsWithChildren<ICarouselWrapperProps>
> = (props) => {
    return (
        <div
            className={"default_layout"}
            key={`{right-banner-${props.index}}`}
            style={{
                height: "6.26rem",
                paddingLeft: "0.2rem",
                paddingRight: "0.2rem",
            }}
        >
            {props.children}
        </div>
    );
};

export default CarouselWrapper;
